// api
import { AxiosResponse } from "axios";
import { axiosClient } from "../../axiosClient";
import { axiosSafeRequest } from "../../axiosSafeRequest";

export interface ContactFormPayload {
  name: string;
  email: string; // requester email
  companyName: string;
}

/**
 * Send contact form data to the server.
 * @param payload Contact form data
 * @returns An HTTP response or undefined if failed
 */
export const apiSendContactForm = async (
  payload: ContactFormPayload
): Promise<AxiosResponse | undefined> => {
  return axiosSafeRequest(() => axiosClient.post(`/contact/query`, payload));
};
